module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.9370/img/app-marketplace-network-1x.png"